<fieldset>
  <legend class="sr-only">PIN Login</legend>
  <div data-cy="pin-wrapper" class="pin-wrapper" [class.pin-wrapper--code-hidden]="isCodeHidden()">
    @for (field of digits.controls; track field; let i = $index) {
      <input
        #inputs
        type="tel"
        class="pin-input"
        [maxLength]="1"
        [formControl]="field"
        (paste)="onPaste($event)"
        (keydown.backspace)="backspace(i, $event)"
      />
    }
  </div>
</fieldset>
